import request from "@/utils/request";

// 获取所有产品结构：试用申请时会用到该接口
// function getAppConfigApi(data) {
//   return request({
//     url: "/GetAppConfigs",
//     method: "post",
//     data
//   });
// }

// 获取授权产品结构，登录首页用到该接口
function getAuthProducts(data) {
  return request({
    url: "/v3/iw-framework/index/get-auth-products",
    method: "post",
    data
  });
}

// 最近使用的产品
function getUsedProducts(data) {
  return request({
    url: "/v3/iw-framework/index/get-used-products",
    method: "post",
    data
  });
}

// 登记用户访问应用
function visitProduct(data) {
  return request({
    url: "/v3/iw-framework/index/visit-product",
    method: "post",
    data: { data }
  });
}

function getProductMenu(data) {
  return request({
    url: "/GetProductMenu",
    method: "post",
    data
  });
}

// 产品菜单
function getAppConfig(data) {
  return request({
    url: "/v3/iw-framework/menu/get-all-menu",
    method: "post",
    data
  });
}
// 申请试用接口----nqr0428
// 申请产品获取
function getAllProducts(data, params) {
  return request({
    url: "/v3/iw-framework/index/get-all-products",
    method: "post",
    data: { data },
    params
  });
}
function getAllProductsTry(data, params) {
  return request({
    url: "/v3/iw-framework/index/get-all-products-try",
    method: "post",
    data: { data },
    params
  });
}
// 立即申请
function tryApply(data) {
  return request({
    url: "/v3/iw-framework/user/tryApply",
    method: "post",
    data: { data }
  });
}

// 行业洞察列表数据
function getArticlesList(data) {
  return request({
    url: "/v3/iw-framework/index/app/getArticleForApp",
    method: "post",
    data
  });
}
// 智见洞察首页文章列表
function getEvNewsList(data) {
  return request({
    url: "/evnews-api/index/list-index-information",
    method: "post",
    data
  });
}

function getUserInfoForLanYing() {
  // 获取蓝鹰用户信息key
  return request({
    url: "/iways-front/func/getLanYingEnterpriseKey",
    method: "get"
  });
}

export {
  // getAppConfigApi,
  getAuthProducts,
  getUsedProducts,
  visitProduct,
  getProductMenu,
  getAppConfig,
  getAllProducts,
  getAllProductsTry,
  tryApply,
  getArticlesList,
  getEvNewsList,
  getUserInfoForLanYing
};
